// Centralized route definitions for the app

export const ROUTES = {
  login: '/login',
  dashboard: '/dashboard',
  fileImporter: '/file-upload', // File Upload (was file-upload)
  fileImporterLegacy: '/file-upload-legacy', // File Upload (legacy server validation)
  fileImporterFiles: '/file-upload/files', // File Upload - uploaded files view
  studyDataImporter: '/data-import', // Data Import (was data-import)
  csvImporter: '/csv-upload', // CSV Upload (was csv-upload)
  auditTrail: '/audit-trail',
  studyFiles: '/study-files', // Study Files Manager
  whitelistManagement: '/whitelist-management', // Whitelist Management
  settings: '/settings',
  designSystem: '/design-system',
};

// List of private routes for navigation and access checks
export const PRIVATE_ROUTES = [
  ROUTES.fileImporter,
  ROUTES.fileImporterLegacy,
  ROUTES.fileImporterFiles,
  ROUTES.studyDataImporter,
  ROUTES.csvImporter,
  ROUTES.auditTrail,
  ROUTES.studyFiles,
  ROUTES.whitelistManagement,
  ROUTES.settings,
];
